let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hgVRH")).then(() => parcelRequire('cJ3vp'));